import { useQuery } from "@tanstack/react-query";
import { notificationList } from "../../api/apiCallManager";

const useNotifications = (options = {}) => {
  return useQuery({
    queryKey: ["notifications_"],
    queryFn: notificationList,
    ...options,
  });
};

export default useNotifications;

// const readCount = notifications.filter((n) => n.read_status === "true").length;
